import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { compose, path, nthArg } from 'ramda'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useEffect } from 'react'
import {
  selectAccessLevelsStatus,
  selectAccessLevels,
  fetchAccessLevels,
  selectAccessLevelLinkedServiceById,
  fetchAccessLevelLinkedServices,
  selectSelectedLinkedService,
  errorMessageChanged,
} from '../admin.slice'

export default () => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let accessLevelsStatus = useAppSelector(selectAccessLevelsStatus)
  let accessLevels = useAppSelector(selectAccessLevels)
  let accessLevelLinkedService = useAppSelector(
    selectAccessLevelLinkedServiceById(selectedLinkedService),
  )

  useEffect(() => {
    if (accessLevelsStatus === 'uninitialized') {
      dispatch(fetchAccessLevels())
    }
  }, [accessLevelsStatus])

  let onAccessLevelChanged = (accessLevel: string) => {
    if (accessLevel === 'None') {
      axios
        .delete(
          `/api/v2/admin/access-level/linked-service?linkedServiceID=${selectedLinkedService}`,
        )
        .then(() => {
          dispatch(fetchAccessLevelLinkedServices())
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
        })
    } else if (accessLevel && !accessLevelLinkedService) {
      axios
        .post('/api/v2/admin/access-level/linked-service', {
          accessLevelID: accessLevel,
          linkedServiceID: selectedLinkedService,
        })
        .then(() => {
          dispatch(fetchAccessLevelLinkedServices())
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
        })
    } else if (accessLevel && accessLevelLinkedService) {
      axios
        .put('/api/v2/admin/access-level/linked-service', {
          accessLevelID: accessLevel,
          linkedServiceID: selectedLinkedService,
        })
        .then(() => {
          dispatch(fetchAccessLevelLinkedServices())
        })
        .catch((err) => {
          dispatch(errorMessageChanged(err?.response?.data))
        })
    }
  }

  return (
    <FormControl variant="standard" sx={{ width: 200 }}>
      <InputLabel htmlFor="state">Access Level</InputLabel>
      <Select
        fullWidth
        value={
          accessLevels.find((x) => x.id === accessLevelLinkedService?.id)?.id ??
          'None'
        }
        onChange={compose(
          onAccessLevelChanged,
          path(['target', 'value']) as any,
          nthArg(0),
        )}
      >
        {[
          <MenuItem key="None" value="None">
            None
          </MenuItem>,
          ...accessLevels.map((al) => (
            <MenuItem key={al.id} value={al.id}>
              {al.name}
            </MenuItem>
          )),
        ]}
      </Select>
    </FormControl>
  )
}
